import { Component, OnInit, OnChanges, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { Pcategory } from '../../models/pcategory';
import { Product } from '../../models/product';
import { Pizza } from '../../models/pizza';
import { PizzaConfig } from '../../models/pizza-config';

import { Utils } from '../../helpers/utils';

import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-order-pizza',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NgbAccordionModule
  ],
  templateUrl: './order-pizza.component.html',
  styleUrl: './order-pizza.component.scss',
})
export class OrderPizzaComponent implements OnInit, OnChanges {
  config = input.required<PizzaConfig>();
  existing = input<Pizza>();
  mode = input<'delivery'|'onsite'>();
  categoriesInput = input<Pcategory[]>([]);
  onDone = output<Pizza>();
  onCancel = output<void>();

  pizza: Pizza;
  pConfig: PizzaConfig;

  modeDone: boolean = false;

  cantMix: string[] = [];
  maxFlavors: number = 1;
  maxCrusts: number = 0;
  flavorsDone: boolean = false;
  chosenCrusts: any = {};
  crustsDone: boolean = false;

  chosenIngredients: any = {};
  ingredientsDone: boolean = false;
  noteDone: boolean = false;

  categories: Pcategory[] = [];

  constructor() {}

  ngOnInit() {
    this.pConfig = this.config();
    this.pizza = this.existing() || new Pizza(this.pConfig);
    if(this.mode()) {
      this.pizza.setMode(this.mode());
      this.modeDone = true;
    }
    this.flavorsDone = this.pizza.flavors.length > 0;
    this._applyCategories();
    for(let crust of this.pConfig.crusts || []) {
      this.chosenCrusts[crust.name] = false;
    }
    for(let ingredient of this.pConfig.ingredients || []) {
      this.chosenIngredients[ingredient.name] = false;
    }
  }

  ngOnChanges() {
    this._applyCategories();
    if(this.pizza && this.pizza.size) {
      this._setPrices(this.pizza.size);
    }
  }

  resetPizza() {
    this.pizza = new Pizza(this.pConfig);
    this.modeDone = this.flavorsDone = this.crustsDone = this.ingredientsDone = false;

    this.chosenCrusts = {};
    for(let crust of this.pConfig.crusts || []) {
      this.chosenCrusts[crust.name] = false;
    }

    this.chosenIngredients = {};
    for(let ingredient of this.pConfig.ingredients || []) {
      this.chosenIngredients[ingredient.name] = false;
    }

    this.cantMix = [];
    for(let pcat of this.categories) {
      pcat.mixBlocked = false;
    }

    if(this.mode()) {
      this.pizza.setMode(this.mode());
      this.modeDone = true;
    }
  }

  chooseMode(mode: 'delivery'|'onsite') {
    this.pizza.setMode(mode);
    this.modeDone = true;
  }
  chooseSize(sizeName: string) {
    this.pizza.setSize(sizeName);
    this._setPrices(sizeName);
  }
  chooseFlavor(pcatName: string, product: Product) {
    if(this.pizza.flavors.length == 0) {
      this.chooseFirstFlavor(pcatName, product);
    } else {
      try {
        this.pizza.setAnotherFlavor(pcatName, product.name, (product.parsedAdditionalInfo || {})["pizza_prices"] || [], product.id);
      } catch (e) {
        if(e.message && e.message.indexOf("cannot mix category")) {
          const cat = e.message.split("cannot mix category")[1] || " este";
          alert(`Não se pode combinar o sabor escolhido anteriormente com ${cat}`);
        }
        console.error(e);
      }
    }

    if(this.maxFlavors == this.pizza.flavors.length)
      this.flavorsDone = true;

    if(this.flavorsDone)
      this.skipEmptyAddons();

    if(this.maxCrusts == this.pizza.crusts.length)
      this.crustsDone = true;
  }
  chooseFirstFlavor(pcatName: string, product: Product) {
    let aux = this.pizza.setFirstFlavor(pcatName, product.name, (product.parsedAdditionalInfo || {})["pizza_prices"] || [], product.id);
    let canMix = aux.canMix;
    this.cantMix = [];
    for(let cat of this.categories) {
      if(canMix.indexOf(cat.name) == -1 && cat.name != pcatName) {
        this.cantMix.push(cat.name);
        cat.mixBlocked = true;
      }
    }
    this.maxFlavors = aux.maxFlavors;
    this.maxCrusts = aux.maxCrusts;
  }
  chooseCrust(crustName: string) {
    this.chosenCrusts[crustName] = !this.chosenCrusts[crustName];
    let i = this.pizza.crusts.indexOf(crustName);
    if(i > -1) {
      this.pizza.crusts.splice(i, 1);
    } else {
      this.pizza.crusts.push(crustName);
    }
    if(this.maxCrusts == this.pizza.crusts.length)
      this.finishCrusts();
  }
  finishFlavors() {
    this.flavorsDone = true;
    this.skipEmptyAddons();
  }
  finishCrusts() {
    let crusts: string[] = [];
    for(let key in this.chosenCrusts) {
      if(this.chosenCrusts[key])
        crusts.push(key);
    }
    this.pizza.setCrusts(crusts);
    this.crustsDone = true;
    this.skipEmptyAddons();
  }
  chooseIngredient(ingredientName: string) {
    this.chosenIngredients[ingredientName] = !this.chosenIngredients[ingredientName];
    let i = this.pizza.ingredients.indexOf(ingredientName);
    if(i > -1) {
      this.pizza.ingredients.splice(i, 1);
    } else {
      this.pizza.ingredients.push(ingredientName);
    }
  }
  finishIngredients() {
    let ingredients: string[] = [];
    for(let key in this.chosenIngredients) {
      if(this.chosenIngredients[key])
        ingredients.push(key);
    }
    this.pizza.setIngredients(ingredients);
    this.ingredientsDone = true;
  }

  finishNote() {
    this.noteDone = true;
  }

  confirmPizza() {
    this.onDone.emit(this.pizza);
  }

  stepBack() {
    if(this.noteDone) {
      this.noteDone = false;
      return;
    }
    if(this.ingredientsDone) {
      this.ingredientsDone = false;
      return;
    }
    if(this.crustsDone) {
      this.crustsDone = false;
      return;
    }
    if(this.flavorsDone) {
      this.flavorsDone = false;
      return;
    }
    if(this.pizza.flavors.length > 0) {
      this.pizza.clearFlavors();
      for(let pcat of this.categories) {
        pcat.mixBlocked = false;
      }
      return;
    }
    if(this.pizza.size) {
      this.pizza.size = '';
      return;
    }
    if(!this.mode()) {
      this.pizza.mode = undefined;
      this.modeDone = false;
      return;
    }
    this.onCancel.emit();
  }

  skipEmptyAddons() {
    if(!this.pConfig.crusts?.length) {
      this.pizza.setCrusts([]);
      this.crustsDone = true;
    }
    if(this.crustsDone && !this.pConfig.ingredients?.length) {
      this.pizza.setIngredients([]);
      this.ingredientsDone = true;
    }
  }

  private _applyCategories() {
    const incoming = this.categoriesInput() || [];
    this.categories = incoming.filter(pcat => {
      const name = (pcat.name || '').toLowerCase();
      return name.indexOf('pizzas ') == 0 || name.indexOf('pizza') == 0;
    });
    for(let pcat of this.categories) {
      if(pcat.products) {
        Product.setArrayAdditionalData(pcat.products);
      }
    }
  }

  private _setPrices(sizeName: string) {
    let modePrice = this.pizza.modePrice || 0;
    for(let pcat of this.categories) {
      for(let prod of (pcat.products || [])) {
        const prices = (prod.parsedAdditionalInfo || {})["pizza_prices"] || [];
        const found = Utils.findById(sizeName, prices, "size_name");
        prod.prettyPrice = (((found && found["price"]) || 0) + modePrice).toFixed(2);
      }
    }
    for(let crust of this.pConfig.crusts || []) {
      const found = Utils.findById(sizeName, crust.prices || [], "size_name");
      crust.sizePrice = found ? found["price"] : 0;
    }
    for(let ingredient of this.pConfig.ingredients || []) {
      const found = Utils.findById(sizeName, ingredient.prices || [], "size_name");
      ingredient.sizePrice = found ? found["price"] : 0;
    }
  }
}
